module.exports = __webpack_public_path__ + "static/media/video2.a01f1ea1.png";